export default __webpack_public_path__ + "static/media/t6.ab24a1d2.png";